export default __webpack_public_path__ + "static/media/Deepika Naharas.32f6e391.jpg";